/*
 *  @providesModule MatchSelectListStyle
 */
import ComponentStyles from 'ComponentStyles';
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import ClientPropertyConstants from 'ClientPropertyConstants';
import {Platform, StyleSheet} from 'react-native';

const {
  btnTextColorTwo,
  fontPrimary,
  fontSecondary,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  textColorPrimary,
  textColorSecondary,
  viewCornerRadiusSecondary,
  viewPrimaryColor,
} = SkillzStyle.fullStyles;

export const TABLET_PADDING_HORIZONTAL = Platform.select({
  ios: {
    paddingHorizontal: Sizes.orientation({
      portrait: 102,
      landscape: 190,
    }),
  },
  android: {
    paddingHorizontal: Sizes.orientation({
      portrait: 20,
      landscape: 190,
    }),
  },
});

// eslint-disable-next-line no-magic-numbers
const sectionBackgroundColor = {
  backgroundColor: SkillzStyle.convertToOpacity(viewPrimaryColor.backgroundColor, 0.8),
};

const isTournamentTemplateUIV2 = ClientPropertyConstants.getTournamentTemplateUIV2Enabled();
export const matchListMarginHorizontal = Sizes.select({
  tabletLandscape: 14,
  other: 10,
});

const MatchSelectStyle = StyleSheet.create({
  matchList: {
    backgroundColor: 'transparent',
    paddingLeft: Sizes.orientation({
      landscape: 1,
      portrait: 0,
    }),
    flex: 1,
    ...Platform.select({
      ios: {
        marginHorizontal: matchListMarginHorizontal,
      },
      android: {
        marginHorizontal: matchListMarginHorizontal,
      },
      web: {marginHorizontal: 5},
    }),
  },

  matchListSkillzNewsV2: {
    ...Sizes.select({
      phone: {
        overflow: 'visible',
      },
    }),
  },

  iPadInnerContainer: {
    flexGrow: 1,
    ...TABLET_PADDING_HORIZONTAL,
  },

  iPadSectionListBackground: {
    ...Platform.select({
      ios: {
        backgroundColor: ComponentStyles.container2.backgroundColor,
      },
      android: {
        backgroundColor: ComponentStyles.container2.backgroundColor,
      },
    }),
    flex: 1,
  },

  iPadBackgroundImage: {
    flexGrow: 1,
    backgroundColor: 'transparent',
    borderRadius: ComponentStyles.container2.borderRadius,
    justifyContent: 'center',
    marginTop: 0,
    ...Platform.select({
      android: {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
      },
    }),
  },

  sectionFooter: {
    ...sectionBackgroundColor,
    height: 5,
    borderBottomRightRadius: viewCornerRadiusSecondary.borderRadius,
    borderBottomLeftRadius: viewCornerRadiusSecondary.borderRadius,
  },

  itemSeparator: {
    ...sectionBackgroundColor,
    height: 12,
  },

  cellWrapper: {
    ...sectionBackgroundColor,
    paddingHorizontal: isTournamentTemplateUIV2 ? 0 : 5,
  },

  lastCellBorder: {
    borderBottomLeftRadius: isTournamentTemplateUIV2 ? 12 : 0,
    borderBottomRightRadius: isTournamentTemplateUIV2 ? 12 : 0,
  },

  semiAlphaSection: {
    ...sectionBackgroundColor,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderRadius: 4,
    marginVertical: 10,
    paddingHorizontal: 5,
    paddingVertical: 5,
  },

  sectionFooterSpacing: {
    marginBottom: 10, // meant to match the spacing in semiAlphaSection
  },

  enterMatchCodeText: {
    ...fontSizeH4,
    ...fontSecondary,
    ...btnTextColorTwo,
    padding: 0,
  },

  enterMatchCodeButton: {
    height: 30,
    flexGrow: 1,
  },

  noResultsContainer: {
    ...sectionBackgroundColor,
    alignItems: 'center',
    height: 24,
  },

  noResultsText: {
    ...fontSizeH4,
    ...fontPrimary,
    ...textColorPrimary,
    marginVertical: 2,
    textAlign: 'center',
    textAlignVertical: 'center',
  },

  backgroundImage: {
    flexGrow: 1,
    backgroundColor: 'transparent',
    marginBottom: -60,
    paddingBottom: 60,
  },

  ftueBoxLayout: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    paddingVertical: 10,
    justifyContent: Sizes.orientation({
      portrait: Sizes.dynamic({
        sm: 'flex-end',
        md: 'center',
      }),
      landscape: Sizes.dynamic({
        sm: 'flex-end',
        xxlg: 'center',
      }),
    }),
    alignItems: 'center',
  },

  ftueBodyText: {
    textAlign: 'center',
    marginTop: 4,
    width: Sizes.dynamic({
      sm: 240,
      lg: 280,
    }),
    fontSize: Sizes.dynamic({
      sm: fontSizeH4.fontSize,
      lg: fontSizeH3.fontSize,
    }),
    lineHeight:
      Sizes.dynamic({
        sm: fontSizeH4.fontSize,
        lg: fontSizeH3.fontSize,
      }) + 4,
    ...textColorSecondary,
    ...fontPrimary,
  },

  ftueHeaderText: {
    textAlign: 'center',
    fontSize: Sizes.dynamic({
      sm: fontSizeH3.fontSize,
      lg: fontSizeH2.fontSize,
    }),
    ...textColorSecondary,
    ...fontSecondary,
  },

  newsBannerViewNoScroll: {
    marginBottom: -10,
    marginHorizontal: -4,
  },

  newsBannerViewScroll: {
    marginBottom: -10,

    ...Sizes.select({
      tabletLandscape: {
        marginHorizontal: -18,
      },
      other: {
        marginHorizontal: -14,
      },
    }),
  },

  ftueTrainerContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
  },
});

export {MatchSelectStyle as default};
